export { useTabs } from './hooks';
export { tabsReducer } from './reducer';
